export const CREATE_EVENT = 'CREATE_EVENT'

export const CREATE_EVENT_action = (data) => {
    return {
        type: CREATE_EVENT,
        info: data
    }
}